import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';

import {
  Menu,
} from '@uncinc/react-drupal-core';

import {
  ButtonWrapper,
} from '../../../components';

const HighlightedMenu = ({ onItemClick }) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));

  return (
    <Menu id="highlighted">
      {(items) => {
        return (
          <>
            {items.map((item) => {
              if (item) {
                const title = item.getIn(['link', 'title'], 'Untitled');
                const url = item.getIn(['link', 'url'], '');
                const active = item.getIn(['link', 'url']) === currentPage;
                const HighlightedMenuItemClassnames = c('HighlightedMenuItem Button', {
                  'HighlightedMenuItem Button--secondary--active': active,
                });

                return (
                  <div
                    key={title}
                    className={HighlightedMenuItemClassnames}
                  >
                    <ButtonWrapper type="secondary" href={url} onClick={onItemClick}>{title}</ButtonWrapper>
                  </div>
                );
              }
            })}
          </>
        );
      }}
    </Menu>
  );
};

export default HighlightedMenu;
